import {
  IAmountSpendInfo,
  IPosIntegationDetails,
  IPurchasedItemInfo,
  envConfig,
} from 'shared-types/index';
import { isEmpty } from 'lodash-es';
import NetworkRequestsService from 'external-services/network-requests-service';
export const axios = NetworkRequestsService.getGlobalAPIWithoutApiHeader();

/**
 * Service to get the weekly/monthly statistics for a customer/venue
 */
class ReportingService {
  /** Provides the customer spend info */
  async getCustomerSpendInfo(
    venueId: number | null,
    customerId: string | null
  ): Promise<IAmountSpendInfo> {
    const amtDetails = {} as IAmountSpendInfo;

    if (!customerId || !venueId) {
      return amtDetails;
    }

    const url = `${envConfig.iPosServiceUrl}/internal/venues/${venueId}/reports/customer-spends?customerIds=${customerId}`;

    try {
      const apiResponse = await axios.get<IAmountSpendInfo[]>(url, {
        headers: {
          'X-API-KEY': `${envConfig.iPosServiceApiKey}`,
        },
      });
      if (!isEmpty(apiResponse.data)) {
        const customerInfo = apiResponse.data[0];
        amtDetails.averageSpend = customerInfo.averageSpend;
        amtDetails.totalSpend = customerInfo.totalSpend;
      }
    } catch (e) {
      console.log(e);
    }
    return amtDetails;
  }

  async getVenuePosInfo(venueId: number): Promise<IPosIntegationDetails[]> {
    let venuePosInfo = [] as IPosIntegationDetails[];
    if (!venueId) {
      return venuePosInfo;
    }

    const url = `${envConfig.iPosServiceUrl}/internal/venues/${venueId}/subscriptions/`;

    try {
      const apiResponse = await axios.get<IPosIntegationDetails[]>(url, {
        headers: {
          'X-API-KEY': `${envConfig.iPosServiceApiKey}`,
        },
      });
      if (!isEmpty(apiResponse.data)) {
        venuePosInfo = apiResponse.data;
      }
    } catch (e) {
      console.log(e);
    }

    return venuePosInfo;
  }

  /** Provides the customer spend info */
  async getCustomersSpendInfo(venueId: number, customerIds: string[]): Promise<IAmountSpendInfo[]> {
    let amtDetails = [] as IAmountSpendInfo[];

    if (!customerIds || !venueId) {
      return amtDetails;
    }

    const url = `${
      envConfig.iPosServiceUrl
    }/internal/venues/${venueId}/reports/customer-spends?customerIds=${customerIds.join(',')}`;

    try {
      const apiResponse = await axios.get<IAmountSpendInfo[]>(url, {
        headers: {
          'X-API-KEY': `${envConfig.iPosServiceApiKey}`,
        },
      });
      if (!isEmpty(apiResponse.data)) {
        amtDetails = apiResponse.data;
      }
    } catch (e) {
      console.log(e);
    }
    return amtDetails;
  }

  /** Provides the list of items consumed by the customer till date */
  async getPurchasedItemsByCustomerId(
    venueId: number,
    customerId: string
  ): Promise<IPurchasedItemInfo[]> {
    if (!customerId) return [];

    let result = [] as IPurchasedItemInfo[];
    const url = `${envConfig.iPosServiceUrl}/internal/venues/${venueId}/reports/customer/${customerId}/Items`;
    try {
      const apiResponse = await axios.get<IPurchasedItemInfo[]>(url, {
        headers: {
          'X-API-KEY': `${envConfig.iPosServiceApiKey}`,
        },
      });
      if (apiResponse && apiResponse.data) result = apiResponse.data;
    } catch (e) {
      console.log(e);
    }
    return result;
  }

  getAvgSpendAmountForBooking(customerId: string, customersSpendInfo: IAmountSpendInfo[]): number {
    const customerSpendInfo = customersSpendInfo.find(
      (customer) => customer.customerId === customerId
    );
    return customerSpendInfo && customerSpendInfo.averageSpend > 0
      ? customerSpendInfo.averageSpend / 100
      : 0;
  }

  async getCustomerAmountDetails(venueId: number, customerId: string): Promise<number> {
    let amtDetails = {} as IAmountSpendInfo;
    if (customerId && venueId) {
      amtDetails = await this.getCustomerSpendInfo(venueId, customerId);
    }
    return !isEmpty(amtDetails) && amtDetails.averageSpend > 0 ? amtDetails.averageSpend / 100 : 0;
  }
}
const instance = new ReportingService();
export default instance as ReportingService;
